export default {
    /** 공통 **/

    // 페이지 로딩 실패
    'page.loading.failure.title': '페이지 가져오기 실패',
    'page.loading.failure.desc.01': '페이지 로딩을 실패하였습니다.',
    'page.loading.failure.desc.02': '다시시도 혹은 새로고침 버튼을 클릭하여주세요.',

    // 페이지 찾기 실패
    'page.not.found.title': '죄송합니다. 페이지를 찾을 수 없습니다.',
    'page.not.found.desc.01': '존재하지 않는 주소를 입력하셨거나,',
    'page.not.found.desc.02': '요청하신 페이지의 주소가 변경, 삭제되어 찾을 수 없습니다.',

    // 페이지 에러 발생 (ex. 메일조회 시 뒷단에서 에러 발생)
    'page.error.desc': '다른 메뉴로 이동하시거나 새로고침 버튼을 클릭하여주세요.',

    // response error
    'response.error.400': '잘못된 요청입니다.',
    'response.error.401': '로그인이 필요합니다.',//401이면 로그인화면으로 이동하므로 실제로는 사용 안 함
    'response.error.404': '잘못된 요청입니다.',
    'response.error.420': '다른 곳에서 로그인되어 해당 기기에서는 로그아웃되었습니다.',
    'response.error.427': '아이디 혹은 비밀번호가 일치하지 않습니다.',
    'response.error.433': '{maxPermissionCount}회 이상 로그인을 실패하여 로그인할 수 없습니다.<br />관리자에게 문의하시기 바랍니다.',
    'response.error.438': '허용되지 않는 IP이므로 로그인할 수 없습니다.',
    'response.error.440': '관리자 권한이 없습니다.',
    'response.error.441': '사용이 중지된 계정입니다.',
    'response.error.442': '웹메일을 사용할 수 없는 계정입니다.',
    'response.error.512': '최대 수신인수({maxSendRcptCount}명)를 초과하였습니다.',
    'response.error.513': '첨부된 파일정보가 없습니다.',
    'response.error.514': '수신인 에러',
    'response.error.515': '존재하지 않는 메일함입니다.',
    'response.error.516': '존재하지 않는 메일입니다.',
    'response.error.517': '존재하지 않는 수신인입니다. 수신인 주소를 다시 확인해주세요.',
    'response.error.518': '이미 사용중인 메일그룹명입니다.',
    'response.error.519': '사용자가 있는 메일그룹은 삭제할 수 없습니다. 사용자를 다른 메일그룹으로 이동한 뒤 삭제하시기 바랍니다.',
    'response.error.520': '통합관리자는 삭제할 수 없습니다.',
    'response.error.521': '존재하지 않는 아이디입니다.',//관리자 추가 시
    'response.error.522': '이미 관리자로 지정되어 있습니다.',
    'response.error.523': '이미 사용중인 사번입니다.',
    'response.error.524': '이미 사용중인 아이디입니다.',
    'response.error.525': '등록할 수 있는 사용자 수를 초과하였습니다.',
    'response.error.526': '사용할 수 없는 가상아이디입니다.(이미 사용중인 아이디입니다.)',
    'response.error.527': '없는 도메인 정보입니다.',
    'response.error.528': '이미 사용중인 도메인입니다.',
    'response.error.529': '기본도메인 정보 변경을 실패하였습니다.',
    'response.error.530': '도메인 삭제를 실패하였습니다.',
    'response.error.531': '휴면 계정입니다. 웹메일에 접속하셔서 휴면을 해제한 뒤 로그인하시기 바랍니다.',
    'response.error.532': '메일 발송을 성공하였으나, 보낸메일함에 저장하지 못했습니다.',
    'response.error.533': '예약메일 발송을 실패하였습니다.',
    'response.error.534': '이미 사용중인 주소록 그룹명입니다.',
    'response.error.535': '이미 사용중인 회사코드입니다.',
    'response.error.536': '사용자가 있는 회사는 삭제하실 수 없습니다.',
    'response.error.537': '메일함 용량이 초과되어 임시저장에 실패하였습니다.',
    'response.error.538': '메일함 용량이 초과되어 예약메일 발송에 실패하였습니다.',
    'response.error.540': '주소록 업로드 시 등록하실 수 있는 최대 주소는 {contactImportMaxCount}개 입니다.',
    'response.error.541': '업로드된 파일의 첫 행 정보가 잘못되었습니다. 샘플파일을 참고하여 다시 작성하시기 바랍니다.',
    'response.error.542': '업로드된 파일에 등록 가능한 연락처 정보가 없습니다.',
    'response.error.543': '회사의 메일 용량을 초과하여 사용자를 추가할 수 없습니다.',
    'response.error.544': 'spikeadm 관리자 계정은 삭제할 수 없습니다.',
    'response.error.545': '최대 자동전달 갯수({maxForwardingCount}개)를 초과하여 저장에 실패하였습니다.',
    'response.error.601': '현재 비밀번호가 맞지 않습니다. 다시 확인해주세요.',
    'response.error.602': '비밀번호의 최소, 최대 길이를 확인해주세요.',
    'response.error.603': '비밀번호는 영문, 숫자, 특수문자가 반드시 포함되어야 합니다.',
    'response.error.604': '비밀번호에 허용되지 않는 특수문자가 포함되어 있습니다.<br/>사용가능한 특수문자는 ~ ! @ # $ % ^ & * ( ) _ - + = < > ? , . ;',
    'response.error.605': '이전에 사용했던 비밀번호는 사용하실 수 없습니다.',
    'response.error.606': '사용할 수 없는 아이디입니다.(아이디는 4~18자까지 가능합니다.)',
    'response.error.607': '사용할 수 없는 아이디입니다.(영문(a-z), 숫자, 마침표만 사용 가능하고, 마침표는 맨 앞 혹은 맨 뒤에 사용할 수 없습니다.)',

    // 기타 
    'common.add': '추가',
    'common.save': '저장',
    'common.cancel': '취소',
    'common.delete': '삭제',
    'common.modify': '수정',
    'common.refresh': '새로고침',
    'common.retry': '다시시도',
    'common.sort': '정렬',
    'common.search': '검색',
    'common.search.condition.add': '검색 조건 추가',
    'common.sidebar.open': '메뉴 열기',
    'common.sidebar.minimize': '메뉴 최소화',
    'common.sidebar.maximize': '메뉴 최대화',
    'common.list': '목록으로 돌아가기',
    'common.text.empty':'정보없음', // 링크가 걸려있는 곳에 출력할 데이타가 없을 때
    'common.pagination.first.page': '첫 페이지로 이동',
    'common.pagination.prev.page': '이전 페이지로 이동',
    'common.pagination.next.page': '다음 페이지로 이동',
    'common.pagination.last.page': '마지막 페이지로 이동',
    'common.save.success': '정상적으로 저장되었습니다.',
    'common.save.failure': '정보 저장에 실패하였습니다.',
    'common.delete.success': '삭제에 성공하였습니다.',
    'common.delete.failure': '삭제를 실패하였습니다.',
    'common.get.list.failure': '목록정보를 가져오는데 실패하였습니다.',
    'common.get.one.failure': '정보를 가져오는데 실패하였습니다.',
    'common.wrong.address': '이메일 형식이 아닙니다.',
    'common.search.count': '검색결과 {totalCount}',
    'common.data.empty': '데이터가 없습니다.',
    'common.search.empty': '검색 결과가 없습니다.',
    'common.form.required': '필수 입력 항목입니다.',
    'common.form.min.number': '최소 {min}{unit}부터 가능합니다.',
    'common.form.zero.and.positive.number': '0 또는 0보다 큰 숫자만 입력 가능합니다.',
    'common.form.number': '숫자를 입력하세요.',
    'common.form.min.length': '최소 {min}자 이상을 입력하세요.',
    'common.form.max.length': '최대 {max}자까지 입력 가능합니다.',
    'common.form.trim.min.length': '공백을 제외하고 최소 {min}자 이상을 입력하세요.',
    'common.form.max.value': '최대 {max}{unit}까지 가능합니다.',
    'common.name.invalid.characters': '\\ " 문자는 사용할 수 없습니다.',
    'common.wrong.period': '종료일이 시작일 이전으로 지정될 수 없습니다.',
    'common.copyright': 'Copyright © WESOME Co., Ltd. All rights reserved.',
    'common.move.prev.page': '이전 페이지로 이동',
    // webadmin
    'common.move.main.page': '메인 페이지로 이동',
    'common.wrong.fqdn': '도메인 형식이 잘못되었습니다.',
    'common.enabled': '사용',
    'common.disabled': '사용 안 함',
    'common.total': '총',
    'common.days.unit': '일',
    'common.count.unit': '개',
    'common.time.unit': '회',
    'common.metabytes.unit': 'MB',
    'common.gigabytes.unit': 'GB',
    'common.person.unit': '명',
    'common.percent.unit': '%',
    'common.form.number.integer': '정수값을 입력하세요.',
    'common.form.number.0_5': '0.5단위로 입력 가능합니다.',
    /** //공통 **/

    
    /** 로그인/로그아웃 **/
    'product.name': 'SPIKE DOCUMENT',
    'lang.ko': '한국어',
    'lang.en': 'English',
    'lang.language': '언어',

    /** 헤더 **/
    'header.company.select': '회사 선택',
    'header.current.company': '현재 회사 : {name}',

    /** 메뉴명 **/
    'topmenu.document': 'SPIKE DOCUMENT',
    'sidebar.document.file': '문서 관리',
    'sidebar.username': '{name}님',

    /** DatePicker **/
    'datepicker.today.button': '오늘로 입력',

    /** 문서 **/
    'spike.document.search.count': '검색결과 {totalCount}개',
    'spike.document.total.count': '총 {totalCount}개',
    'spike.document.file.date': '생성 시간',
    'spike.document.file.name': '파일 명',
    'spike.document.file.size': '파일 크기',
    'spike.document.file.type': '확장자',

    'spike.document.empty': '등록된 문서가 없습니다..',
}
